import { Stack, Typography, styled } from "@mui/material";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
// import Regeneratepopup from "../MailComponent/Regenratepopup";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Autocomplete from "@mui/material/Autocomplete";

import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { format, parseISO } from "date-fns";
import { useDispatch, useSelector } from "react-redux";

import WelcomeNameContainer from "../LaunchComponent/WelcomeNameContainer";
import {
 fetchCampaignsData,
 handleCampainIDSelection,
 resetSubmissionButton,
} from "../Redux/Mailer";
import { handleGenerateNudge, handleNudgeLoading } from "../Redux/Nudge";
import NudgeDataDisplay from "./nudgeDataDisplay";
import "./nudgeForm.css";
const CustomRadio = styled(Radio)(({ theme }) => ({
 "&.Mui-checked": {
  color: "#9c27b0", // Purple for the checked state
 },
 "& .MuiSvgIcon-root": {
  fontSize: "1.5rem", // Custom icon size
 },
 "&:hover": {
  backgroundColor: "rgba(156, 39, 176, 0.08)", // Optional hover effect
 },
}));
const WhiteBorderTextField = styled(TextField)`
 & label.Mui-focused {
  color: #a804ff;
 }
 & .MuiOutlinedInput-root {
  &.Mui-focused fieldset {
   border-color: #a814ff;
   border-width: 1px;
  }
 }
`;

const NudgeForm = ({
 programList,
 categoryNameNudge,
 setCategoryNameNudge,
 mailerChild,
 setMailerChild,
 setMailerParent,
 mailerParent,
}) => {
 const [programNameNudge, setProgramNameNudge] = useState("");
 const [targAudienceNudge, setTargAudienceNudge] = useState("");
 const [keyMsgNudge, setKeyMsgNudge] = useState("");
 const [keyDatesNudge, setKeyDatesNudge] = useState();
 const [keyHighlightsNudge, setHighlightsNudge] = useState();
 const [stepsNudge, setStepsNudge] = useState();
 const [campaign, setCampaign] = useState(0);
 const campaignList = useSelector((state) => state.model.campaignList);
 const options =
  campaignList.message !== "No campaign for this user." && campaignList.length > 0
   ? campaignList.map((item) => ({ id: item.id, name: item.name }))
   : [];
 const [isNameIncludes, setIsNameIncluded] = useState(false);
 const [contactInfoNudge, setContactInfoNudge] = useState("");
 const [callToActionNudge, setCallToActionNudge] = useState("");
 const [isNudgeMailGenerationClicked, setIsNudgeGenerationClicked] =
  React.useState(false);
 const [isNudgeNavigatedToForm, setIsNudgeNavigatedToForm] = useState(false);
 const isNudegeLoaded = useSelector((state) => state.nudge.isNudgeLoaded);
 const dispatch = useDispatch();
 const [isNudgeMailGenerated, setIsNudgeMailGenerated] = useState("init");
 const handleCampaignID = (val) => {
  if (val) {
   setCampaign(val.id);
   let campaignID = val.id;
   let data = campaignList.filter((val) => val.id == campaignID);
   setProgramNameNudge(data[0].name);

   const endDateItem = data[0].selectedItems.filter(
    (val) => val.title == "Learning Journey End"
   );
   let learningJourneyEnd;
   if (endDateItem.length != 0) {
    learningJourneyEnd = format(parseISO(endDateItem[0].date), "yyyy-MM-dd");
   } else {
    learningJourneyEnd = "";
   }
   setKeyDatesNudge(learningJourneyEnd);
   dispatch(handleCampainIDSelection(campaignID));
  }
 };
 useEffect(() => {
  dispatch(fetchCampaignsData(categoryNameNudge));
 }, []);
 const [value, setValue] = React.useState(null);

 const handleChange = (event) => {
  if (event.target.value == "no") {
   setCampaign(0);
   dispatch(handleCampainIDSelection(0));
  }
  handleRadioChangeReset();

  setValue(event.target.value);
 };
 const today = new Date().toISOString().split("T")[0];
 const handleReset = () => {
  dispatch(resetSubmissionButton());

  setMailerChild("");
  setMailerParent("");
  setCategoryNameNudge("Program");
  setProgramNameNudge("");
  setTargAudienceNudge("");
  setKeyDatesNudge();
  setKeyMsgNudge("");
  setCallToActionNudge("");
  setStepsNudge("");
  setHighlightsNudge("");
  setContactInfoNudge("");
 };
 const handleRadioChangeReset = () => {
  setIsNudgeMailGenerated("init");
  setIsNudgeNavigatedToForm(false);
  dispatch(resetSubmissionButton());
  setCampaign(0);
  setProgramNameNudge("");
  setKeyDatesNudge("");
  setCallToActionNudge("");
  setContactInfoNudge("");
  setKeyMsgNudge("");
 };
 const handleRadioChange = (e) => {
  setCategoryNameNudge(e.target.value);
  setValue("");
  handleRadioChangeReset();
  dispatch(fetchCampaignsData(e.target.value));
 };
 const handleProgramNameChange = (currentName) => {
  setProgramNameNudge(currentName);
 };
 const handleNudgeMailGeneration = () => {
  setIsNudgeGenerationClicked(true);
  let values = {
   programNameNudge: programNameNudge,
   keyDatesNudge: keyDatesNudge,
   targAudienceNudge: targAudienceNudge,
   contactInfoNudge: contactInfoNudge,
   callToActionNudge: callToActionNudge,
   keyMsgNudge: keyMsgNudge,
   keyHighlightsNudge: keyHighlightsNudge,
   stepsNudge: stepsNudge,
   currentContent: "",
   sessionID: localStorage.getItem("sessionId"),
   categoryName: categoryNameNudge,
  };
  dispatch(handleGenerateNudge(values));
 };
 const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
 ))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
   backgroundColor: "#f5f5f9",
   color: "rgba(0, 0, 0, 0.87)",
   maxWidth: 220,
   fontSize: theme.typography.pxToRem(12),
   border: "1px solid #dadde9",
  },
 }));
 const ITEM_HEIGHT = 48;
 const ITEM_PADDING_TOP = 8;
 const MenuProps = {
  PaperProps: {
   style: {
    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    width: 200,
   },
  },
 };
 return (
  <>
   {!isNudgeMailGenerationClicked ? (
    <Stack>
     <Stack sx={{ width: "100%" }}>
      <WelcomeNameContainer currentComp="Nudge" />
      <Stack spacing={1} className="mail-form-container-stack">
       <div className="mail-form-container">
        <div className="mailer-form-categories-section">
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Learning Program</span>
          <input
           type="radio"
           checked={categoryNameNudge === "Program"}
           value="Program"
           name="radio-category"
           onChange={handleRadioChange}
          />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Event</span>
          <input
           type="radio"
           checked={categoryNameNudge === "Event"}
           value="Event"
           name="radio-category"
           onChange={handleRadioChange}
          />
          <span class="mailer-form-categories-checkmark"></span>
         </label>

         <label class="mailer-form-categories-container">
          <span className="mailer-form-categories-text">Webinar</span>
          <input
           type="radio"
           checked={categoryNameNudge === "Webinar"}
           value="Webinar"
           name="radio-category"
           onChange={handleRadioChange}
          />
          <span class="mailer-form-categories-checkmark"></span>
         </label>
        </div>
        <Stack direction={"row"} sx={{ alignItems: "flex-start" }} spacing={2}>
         <Stack direction={"row"} sx={{ alignItems: "flex-start" }} spacing={2}>
          <Stack direction={"column"}>
           <Typography>
            Is this communication part of any campaign?{" "}
            <span style={{ color: "red" }}>*</span>
           </Typography>
           <Typography>(If yes, select the campaign name)</Typography>
          </Stack>

          <FormControl>
           <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={value}
            onChange={handleChange}
            sx={{ paddingLeft: "20px" }}
           >
            <FormControlLabel
             value="yes"
             control={
              <CustomRadio
               icon={<RadioButtonUncheckedIcon style={{ fontSize: "1.3rem" }} />} // Empty circle when unchecked
               checkedIcon={
                <CheckCircleOutlineIcon
                 style={{ fontSize: "1.3rem", color: "#9c27b0" }}
                />
               } // Checkmark inside circle when checked
              />
             }
             label="Yes"
            />
            <FormControlLabel
             value="no"
             control={
              <CustomRadio
               icon={<RadioButtonUncheckedIcon style={{ fontSize: "1.3rem" }} />} // Empty circle when unchecked
               checkedIcon={
                <CheckCircleOutlineIcon
                 style={{ fontSize: "1.3rem", color: "#9c27b0" }}
                />
               } // Checkmark inside circle when checked
              />
             }
             label="No"
            />
           </RadioGroup>
          </FormControl>
         </Stack>
         {value == "yes" && (
          <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={2}>
           <Typography>
            Select the campaign <span style={{ color: "red" }}>*</span>
           </Typography>
           <Stack
            className="mail-form-headers"
            sx={{
             display: "flex",
             flexDirection: "column",
             gap: "10px",
             marginBottom: "10px",
             m: 1,
             width: 200,
             mt: 3,
            }}
            direction={"row"}
            spacing={2}
           >
            {/* <Select value={campaign} onChange={handleCampaignID} MenuProps={MenuProps}>
             {campaignList.message != "No campaign for this user." &&
              campaignList.length > 0 &&
              campaignList.map((item, index) => (
               <MenuItem key={index + 1} value={item.id}>
                {item.name}
               </MenuItem>
              ))}
            </Select> */}
            <Autocomplete
             value={options.find((option) => option.id === campaign) || null}
             onChange={(event, newValue) => {
              handleCampaignID(newValue);
             }}
             options={options}
             getOptionLabel={(option) => option.name || ""}
             ListboxProps={{
              style: {
               maxHeight: "150px", // Fixed height for the dropdown
               overflowY: "auto", // Enable vertical scrolling
              },
             }}
             renderInput={(params) => (
              <TextField
               sx={{ "& .MuiOutlinedInput-root": { padding: "2px !important" } }}
               {...params}
               variant="outlined"
              />
             )}
             filterSelectedOptions={false}
            />
           </Stack>
          </Stack>
         )}
        </Stack>
        <div className="mail-form-wrap">
         <div className="mail-form-inner-wrap">
          <Stack
           className="mail-form-headers"
           sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginBottom: "10px",
            position: "relative",
           }}
          >
           <Typography sx={{ fontSize: "16px" }}>
            <span>
             Name<span style={{ color: "red" }}>*</span>
            </span>
            <HtmlTooltip
             arrow
             title={
              <React.Fragment>
               {categoryNameNudge == "Program" ? (
                <p> Enter the program name </p>
               ) : categoryNameNudge == "Event" ? (
                <p> Enter the event name</p>
               ) : categoryNameNudge == "Microsite/Tool/Platform" ? (
                <p> Enter the Microsite/Tool/Platform name</p>
               ) : (
                <p> Enter the Webinar name</p>
               )}
              </React.Fragment>
             }
            >
             <img
              src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
              style={{ width: "6%", cursor: "pointer" }}
             />
            </HtmlTooltip>
           </Typography>
           {/* <WhiteBorderTextField
            placeholder={
             categoryNameNudge == "Program"
              ? "e.g: Java Full Stack"
              : categoryNameNudge == "Event"
              ? "e.g: Google Cloud Fusion Fest"
              : "e.g: Cloud Computing Webinar"
            }
            id="multiline"
            multiline
            disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
            minRows={1}
            maxRows={2}
            value={programNameNudge}
            InputProps={{
             readOnly: value === "yes" && campaign != 0,
            }}
            InputLabelProps={{ shrink: false }}
            onChange={(event) => {
             setIsNudgeMailGenerated("init");
             handleProgramNameChange(event.target.value);
            }}
            fullWidth
           /> */}
              <Autocomplete
              id="free-solo-demo"
              freeSolo
              value={programNameNudge}
              onChange={(event, newValue) => {
                handleProgramNameChange(newValue || ""); // Ensure value updates when selecting a suggestion
                setIsNudgeMailGenerated("init");
              }}
              onInputChange={(event, newInputValue) => {
                handleProgramNameChange(newInputValue); // Update state when typing
              }}
              disabled={!value || (value === "yes")}
              inputprops={{ readOnly: value === "yes"}}
              options={programList.map((option) => option.programname)}
              renderInput={(params) => (
                <WhiteBorderTextField
                  {...params}
                  id="multiline"
                  multiline
                  minRows={1}
                  maxRows={2}
                  fullWidth
                  placeholder={
                    categoryNameNudge === "Program"
                      ? "e.g: Java Full Stack"
                      : categoryNameNudge === "Event"
                      ? "e.g: ATCI Event"
                      : categoryNameNudge === "Microsite/Tool/Platform"
                      ? "e.g: ATCI Learning"
                      : "e.g: ATCI Webinar"
                  }
                  disabled={!value || (value === "yes" && campaign === 0)} 
                />
              )}
            />
          </Stack>
          <Stack
           className="mail-form-headers"
           sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginBottom: "10px",
           }}
          >
           <Typography sx={{ fontSize: "16px" }}>
            <span>
             Key Date <span style={{ color: "red" }}>*</span>
            </span>
            <HtmlTooltip
             arrow
             title={
              <React.Fragment>
               <p>Specify the final date of completion.</p>
              </React.Fragment>
             }
            >
             <img
              src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
              style={{ width: "6%", cursor: "pointer" }}
             />
            </HtmlTooltip>
           </Typography>
           <input
            type="date"
            className="maindate"
            min={today}
            disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
            style={{ padding: "11px" }}
            readOnly={
             value == "yes" && campaign != 0 && keyDatesNudge != "" ? true : false
            }
            onChange={(event) => {
             setKeyDatesNudge(event.target.value);
             setIsNudgeMailGenerated("init");
            }}
            value={keyDatesNudge}
            onKeyDown={(e) => e.preventDefault()}
           />
          </Stack>
         </div>
         <div className="mail-form-inner-wrap">
          <Stack
           className="mail-form-headers"
           sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginBottom: "10px",
           }}
          >
           <Typography sx={{ fontWeight: "400", fontSize: "16px" }}>
            <span>
             Contact Info<span style={{ color: "red" }}>*</span>
            </span>
            <HtmlTooltip
             arrow
             title={
              <React.Fragment>
               <p>Enter contact info for queries</p>
              </React.Fragment>
             }
            >
             <img
              src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
              style={{ width: "6%", cursor: "pointer" }}
             />
            </HtmlTooltip>
           </Typography>
           <WhiteBorderTextField
            // placeholder="Enter Contact Info"
            placeholder="e.g: support@jfs.com"
            id="multiline"
            multiline
            maxRows={1}
            disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
            InputLabelProps={{ shrink: false }}
            onChange={(event) => {
             setContactInfoNudge(event.target.value);
             setIsNudgeMailGenerated("init");
            }}
            fullWidth
            value={contactInfoNudge}
           />
          </Stack>
          <Stack
           className="mail-form-headers"
           sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginBottom: "10px",
           }}
          >
           <Typography sx={{ fontSize: "16px" }}>
            <span>Target Audience</span>
            <HtmlTooltip
             arrow
             title={
              <React.Fragment>
               <p>Specify target audience</p>
              </React.Fragment>
             }
            >
             <img
              src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
              style={{ width: "6%", cursor: "pointer" }}
             />
            </HtmlTooltip>
           </Typography>
           <WhiteBorderTextField
            // placeholder="Enter Target Audience"
            placeholder="e.g: CL8 – CL10 learners at ATCI"
            id="multiline"
            multiline
            InputLabelProps={{ shrink: false }}
            minRows={1}
            maxRows={2}
            disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
            onChange={(event) => {
             setTargAudienceNudge(event.target.value);
             setIsNudgeMailGenerated("init");
            }}
            fullWidth
            value={targAudienceNudge}
           />
          </Stack>
         </div>

         <Stack
          className="mail-form-headers"
          sx={{
           display: "flex",
           flexDirection: "column",
           gap: "10px",
           marginBottom: "10px",
          }}
         >
          <Typography sx={{ fontWeight: "400", fontSize: "16px" }}>
           {/* Key Highlights <span style={{ color: "lightgray" }}></span> */}
           <span>
            Key Message (Action Required)
            <span style={{ color: "lightgray" }}></span>
           </span>
           <HtmlTooltip
            arrow
            title={
             <React.Fragment>
              {categoryNameNudge == "Program" ? (
               <p>
                Provide key details or actions to be taken (e.g., complete learning
                journey/assignment, take assessment, book exam, participate in quiz, and
                more).
               </p>
              ) : categoryNameNudge == "Event" ? (
               <p>
                Provide key details or actions to be taken (e.g., attend the event,
                participate in quiz, and more).
               </p>
              ) : (
               <p>
                Provide key details or actions to be taken (e.g., attend the event,
                participate in quiz, and more).
               </p>
              )}
             </React.Fragment>
            }
           >
            <img
             src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
             style={{ width: "3%", cursor: "pointer" }}
            />
           </HtmlTooltip>
          </Typography>
          <WhiteBorderTextField
           //placeholder="Key Highlights"
           placeholder={
            categoryNameNudge == "Program"
             ? "e.g: Complete your learning journey and earn a badge and certification."
             : categoryNameNudge == "Event"
             ? "e.g: Here’s an opportunity to participate in this exclusive Google Cloud Fest event."
             : "e.g: Here’s an opportunity to participate in this exclusive Cloud Computing webinar."
           }
           id="multiline"
           multiline
           minRows={3}
           disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
           InputLabelProps={{ shrink: false }}
           onChange={(event) => {
            setKeyMsgNudge(event.target.value);
            setIsNudgeMailGenerated("init");
           }}
           fullWidth
           //    value={keyPoints}
           value={keyMsgNudge}
          />
         </Stack>

         <Stack
          className="mail-form-headers"
          sx={{
           display: "flex",
           flexDirection: "column",
           gap: "10px",
           marginBottom: "10px",
          }}
         >
          <Typography sx={{ fontWeight: "400", fontSize: "16px" }}>
           <span>Call To Action </span>
           <span style={{ color: "lightgray" }}></span>
           <HtmlTooltip
            arrow
            title={
             <React.Fragment>
              <p>Encourage participants to take action.</p>
             </React.Fragment>
            }
           >
            <img
             src={process.env.PUBLIC_URL + "/Images/info_icon.png"}
             style={{ width: "3%", cursor: "pointer" }}
            />
           </HtmlTooltip>
          </Typography>
          <WhiteBorderTextField
           //  placeholder="e.g: Confirm your attendance [here]!"
           id="multiline"
           multiline
           minRows={3}
           disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
           InputLabelProps={{ shrink: false }}
           onChange={(event) => {
            setCallToActionNudge(event.target.value);
            setIsNudgeMailGenerated("init");
           }}
           // sx={{ width: "20rem" }}
           fullWidth
           value={callToActionNudge}
          />
         </Stack>
        </div>
       </div>
       <div className="btn-container">
        {isNudgeNavigatedToForm && (
         <button
          className="reset-btn"
          onClick={() => {
           setIsNudgeMailGenerated("generateOutput");
           setIsNudgeGenerationClicked(true);
          }}
         >
          Next
         </button>
        )}

        {programNameNudge == "" ||
        contactInfoNudge == "" ||
        keyDatesNudge == undefined ||
        isNudgeMailGenerated !== "init" ? (
         <div className="mailer-generate-btn-disable">
          <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}></img>
          <span>Generate</span>
         </div>
        ) : (
         <div
          className="mailer-generate-btn"
          onClick={() => {
           handleNudgeMailGeneration();
           setIsNudgeMailGenerated("generateOutput");
           dispatch(handleNudgeLoading());
          }}
         >
          <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"}></img>
          <span>Generate</span>
         </div>
        )}
       </div>
      </Stack>
     </Stack>
    </Stack>
   ) : isNudgeMailGenerated == "generateOutput" ? (
    <>
     <NudgeDataDisplay
      setIsNudgeGenerationClicked={setIsNudgeGenerationClicked}
      categoryNameNudge={categoryNameNudge}
      mailerChild={mailerChild}
      mailerParent={mailerParent}
      handleReset={handleReset}
      setIsNudgeNavigatedToForm={setIsNudgeNavigatedToForm}
      setIsNudgeMailGenerated={setIsNudgeMailGenerated}
      programNameNudge={programNameNudge}
     />
    </>
   ) : (
    <></>
   )}
  </>
 );
};

export default NudgeForm;
